<template>
  <div id="app">
    <AppHeader />
    <router-view />
  </div>
</template>

<script>
import AppHeader from './layout/appHeader/index'
export default {
  name: 'App',
  components: {
    AppHeader
  },
  created() {
    this.$store.dispatch('user/getUserInfo')
  }
}
</script>
